"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArrayEmpty = void 0;
const isArrayEmpty = (array) => Array.isArray(array) && array.every(exports.isArrayEmpty);
exports.isArrayEmpty = isArrayEmpty;
